import { Directive, ElementRef, Input, OnInit, effect } from '@angular/core';
import { Rol } from '../interfaces/roles';
//import { NgIf } from '@angular/common';
import { RolesService } from '../services/roles.service';

@Directive({
  selector: '[ocultar-roles]',
  standalone: true,
})
export default class RolOcultarDirective implements OnInit{

  @Input({required: true}) ocultos!: Rol[];

  constructor(
    private readonly rolService: RolesService,
    //private readonly ngIfDirective:NgIf,
    private elementRef: ElementRef
    ) {}

    hola = effect(()=> {
      //Pongo el rolService en el effect para que se ejecute
      if(!this.ocultos && this.rolService.rol()) return;
      this.revisarRol()
    })

  ngOnInit(): void {
    this.revisarRol()
  }

  revisarRol(){
    const ocultar = this.ocultos.includes(this.rolService.rol());
    this.elementRef.nativeElement.style.display = (!ocultar || this.rolService.rol() === "admin") ? "block" : "none";
    return
  }
}
